import TranslatedMessage from "./TranslatedMessage";

import CustomListWithZeroData from "../variables/variables.json";

const CustomListWithZero = (props) => {
	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsSection = props.section;
	const formattedMessage = "miasta." + propsMiasto + "." + propsSection;

	return (
		<>
			<ol className="custom-list-with-zero">
				{CustomListWithZeroData.miasta[propsMiasto].customlistwithzero[propsSection].map(
					(customlistwithzero, index) => (
						<li key={index}>
							<div className="custom-list-with-zero__content">
								<TranslatedMessage id={customlistwithzero.title} />
								{customlistwithzero.sublist && (
									<ul className="pd-custom-list">
										{customlistwithzero.sublist.map((sublist, index) => (
											<li key={index}>
												<TranslatedMessage id={sublist.title} />
											</li>
										))}
									</ul>
								)}
							</div>
						</li>
					),
				)}
			</ol>
		</>
	);
};

export default CustomListWithZero;
